// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"ShopifyStoreField_fieldWrapper__7YOt9","inputSection":"ShopifyStoreField_inputSection__3cGov"};